// Year
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = new Date().getFullYear();

// Mobile menu toggle (basic)
const menuBtn = document.getElementById('menuBtn');
const nav = document.querySelector('.nav');
if (menuBtn && nav) {
  menuBtn.addEventListener('click', () => {
    const open = nav.classList.toggle('nav--open');
    menuBtn.setAttribute('aria-expanded', String(open));
  });
}

// Header shadow on scroll
const header = document.getElementById('header');
const onScroll = () => {
  if (window.scrollY > 8) header.classList.add('header--scrolled');
  else header.classList.remove('header--scrolled');
};
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

// Cart wiring is handled by cart.js via data-add-to-cart attributes.

// Mobile nav styles when open
const style = document.createElement('style');
style.textContent = `
  @media (max-width: 960px) {
    .nav.nav--open {
      display: flex;
      position: absolute;
      top: 72px;
      left: 0;
      right: 0;
      flex-direction: column;
      gap: 0;
      padding: 16px 24px 24px;
      background: rgba(11,10,8,0.98);
      backdrop-filter: blur(14px);
      border-bottom: 1px solid var(--line);
    }
    .nav.nav--open a {
      padding: 12px 0;
      border-bottom: 1px solid var(--line);
      font-size: 16px;
    }
  }
`;
document.head.appendChild(style);

// Reveal on scroll
const reveal = (el) => {
  el.style.opacity = '1';
  el.style.transform = 'translateY(0)';
};
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      reveal(e.target);
      io.unobserve(e.target);
    }
  });
}, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

// Safety net: if IO never fires (iOS quirks, prefers-reduced-motion, etc.)
// reveal everything after a short timeout so content is never invisible.
const revealAllSafety = () => {
  document.querySelectorAll('.section, .peptides, .brands, .visit, .newsletter').forEach(reveal);
};
window.addEventListener('load', () => setTimeout(revealAllSafety, 1500));

// Brand filter chips (homepage)
const chips = document.querySelectorAll('#shop .prod-filter .chip, .prod-filter[data-main] .chip');
const prods = document.querySelectorAll('.prod[data-brand]');
chips.forEach(chip => {
  chip.addEventListener('click', () => {
    chips.forEach(c => c.classList.remove('is-active'));
    chip.classList.add('is-active');
    const filter = chip.dataset.filter;
    prods.forEach(p => {
      if (filter === 'all' || p.dataset.brand === filter) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  });
});

document.querySelectorAll('.section, .peptides, .brands, .visit, .newsletter').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity .7s ease, transform .7s ease';
  io.observe(el);
});
